module.exports = __webpack_public_path__ + "static/BB-legends-04da31815dfe5911d57c12360178e585.jpg";